.filters {
  margin-bottom: 16px;
}

.subText {
  display: block;
  margin-top: 4px;
  font-size: 12px;
}

.small {
  font-size: 12px;
}

.gap {
  margin-left: 8px;
}

.monospace {
  font-family: Consolas, Monaco, 'Courier New', monospace;
}

.hint {
  display: block;
  margin-top: 8px;
  font-size: 12px;
}

.promptNote {
  padding: 12px;
  margin-top: 12px;
  font-size: 12px;
  background: var(--ant-color-info-bg);
  border-left: 3px solid var(--ant-color-info);
  border-radius: var(--ant-border-radius-sm);
}

.preWrap {
  white-space: pre-wrap;
}

.sectionCard {
  margin-bottom: 16px;
}

.statsRow {
  margin-top: 16px;
}
